// @flow
import * as React from 'react';
import type { Confirmation } from 'speed-js-react';
import MessageDialog from 'esm-web-pro/components/dialogs/MessageDialog';


type Props = {
    confirmations: Array<Confirmation>,
    onClose: (confirmation: Confirmation) => void,
}


const ConfirmationActionsRenderer = (props: Props) => {
    const { confirmations, onClose } = props;
    if (confirmations.length === 2) {
        confirmations.shift();
    }

    return (
        <>
            {
                confirmations.map((confirm) => {
                    const actions = { ...confirm.actions };

                    Object.keys(actions).forEach((key) => {
                        const { callback } = actions[key];
                        actions[key].callback = (e: SyntheticMouseEvent<HTMLButtonElement>) => {
                            e.preventDefault();
                            callback(e);
                            onClose(confirm);
                        };
                    });

                    return (
                        <MessageDialog
                            message={confirm.message}
                            title={confirm.title}
                            actions={actions}
                            actionsAlign={confirm.actionsAlign}
                            position={confirm.position}
                            size={confirm.size}
                            key={confirm.message}
                        />
                    );
                })
            }
        </>
    );
};


export default React.memo<Props>(ConfirmationActionsRenderer);
